import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  PricingByCheckoutIdView,
  ViewPricingByCheckoutIdResult,
} from "../../../projection/pricing/viewPricingByCheckoutId";

interface HttpPricingByCheckoutIdView extends PricingByCheckoutIdView {}

interface HttpPricingByCheckoutIdViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpPricingByCheckoutIdViewFunction {
  (args: HttpPricingByCheckoutIdViewFunctionArgs): HttpPricingByCheckoutIdView;
}

const httpPricingByCheckoutIdView: HttpPricingByCheckoutIdViewFunction =
  ({ httpPost }) =>
  async ({ checkoutId, signal }) =>
    await httpPost<ViewPricingByCheckoutIdResult>({
      endpoint: "/view-checkout-pricing-by-checkout-id",
      body: { checkoutId },
      signal,
      result: {
        error: null,
        success: (response) => response,
      },
    });

export { httpPricingByCheckoutIdView };
